"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipLabel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _ChipLabel = require("./ChipLabel.styles");
/**
 * A wrapper for the text node inside of an AssistChip. Allows us to truncate long
 * label text.
 *
 * @since 8.97.0
 */
var ChipLabel = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_ChipLabel.StyledChipLabel, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.ChipLabel = ChipLabel;
ChipLabel.displayName = 'ChipLabel';